import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  Select,
  Typography,
} from "antd";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import PressureSoreTable from "../CommonComponents/ClinicalProgress/PressureSoreModal";
import GcsScaleModal from "../CommonComponents/ClinicalProgress/GcsScaleModal";
import { prophylaxisKeys } from "../formsKeys";
import useReceptionistMobilePickerProps from "../../../Receptionist/receptionistMobilePickerProps";

const ReviewClinicalProgress = ({
  form,
  setPressureSorePoints,
  pressureSorePoints,
  hidePressureSore = false,
  stayHospital,
}) => {
  const mobilePickerProps = useReceptionistMobilePickerProps();
  const [openGcs, setOpenGcs] = useState(false);
  const [gcsBreakdown, setGcsBreakdown] = useState(null);
  const gcsScore = Form.useWatch(["clinical_progress", "gcs"], form);

  useEffect(() => {
    if (!form || !stayHospital) return;
    const current = form.getFieldValue(["clinical_progress", "stay"]);
    if (current === undefined || current === null || current === "") {
      form.setFieldValue(["clinical_progress", "stay"], stayHospital);
    }
  }, [form, stayHospital]);

  const openGcsScale = () => {
    setGcsBreakdown(form?.getFieldValue(["clinical_progress", "gcs_scale"]));
    setOpenGcs(true);
  };

  const applyGcsScore = (result) => {
    form?.setFieldValue(["clinical_progress", "gcs"], String(result.score));
    form?.setFieldValue(["clinical_progress", "gcs_scale"], result);
    setGcsBreakdown(result);
  };

  return (
    <>
      <Typography className="forms-ip-sentence">
        <Typography.Text>
          He/She remained cardiovascularly stable, However with a GCS of{" "}
        </Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["clinical_progress", "gcs"]}
        >
          <Input className={inputStyles.mdInput} style={{ width: "150px" }} />
        </Form.Item>
        <Button
          type="primary"
          className="forms-ip-scale-btn"
          onClick={openGcsScale}
        >
          {gcsScore ? "Edit Scale" : "Add Scale"}
        </Button>
      </Typography>
      <Typography className="forms-ip-sentence">
        <Typography.Text>During his/her stay at </Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["clinical_progress", "stay"]}
        >
          <Input className={inputStyles.mdInput} />
        </Form.Item>
        <Typography.Text>
          {" "}
          , patient underwent regular physiotherapy and other symptomatic and
          supportive care for his/her functional recovery.
        </Typography.Text>
      </Typography>
      <Typography className="forms-ip-sentence">
        {/* Unticked, the backend leaves the tracheostomy line out of the PDF. */}
        <Form.Item
          style={{ display: "inline-block", marginRight: 8 }}
          name={["clinical_progress", "tracheostomy_care"]}
          valuePropName="checked"
        >
          <Checkbox />
        </Form.Item>
        <Typography.Text>
          Tracheostomy Care and Respiratory Support was continued. As the
          patient condition improved Tracheostomy was successfully decannulated
          on{" "}
        </Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["clinical_progress", "date"]}
        >
          <DatePicker
            className={inputStyles.mdDatePicker}
            style={{ width: "150px" }}
            inputReadOnly
            {...mobilePickerProps}
          />
        </Form.Item>
      </Typography>
      <Typography className="forms-ip-sentence">
        <Typography.Text>He/She received </Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["clinical_progress", "dvt_prophylaxis"]}
        >
          <Select
            options={prophylaxisKeys}
            className={inputStyles.mdInput}
            style={{ width: "250px" }}
            placeholder="DVT Prophylaxis"
          />
        </Form.Item>
        <Typography.Text> as DVT Prophylaxis</Typography.Text>
      </Typography>
      {!hidePressureSore && (
        <Typography className="forms-ip-sentence">
          <Typography.Text>
            He/She received regular wound care, with frequent change of
            positioning with medical support for the following Pressure Sores
          </Typography.Text>{" "}
          <PressureSoreTable
            setPressureSorePoints={setPressureSorePoints}
            pressureSorePoints={pressureSorePoints}
          />
        </Typography>
      )}
      <Typography className="forms-ip-sentence">
        <Typography.Text>
          He/she is being sent for review as advised by the primary physician.
        </Typography.Text>
      </Typography>
      <GcsScaleModal
        open={openGcs}
        setOpen={setOpenGcs}
        value={gcsBreakdown}
        onApply={applyGcsScore}
      />
    </>
  );
};

export default ReviewClinicalProgress;
